// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table {
  margin-bottom: 0;
}

.table th {
  padding: 0.5rem;
  font-weight: 600;
  font-size: 0.9rem;
}

.table td {
  vertical-align: middle;
  padding: 0.5rem;
}

.table td mat-checkbox label {
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/admin/dashboard/certified-clubs-list/certified-clubs-list.component.scss"],"names":[],"mappings":"AAIA;EACI,gBAAA;AAHJ;;AAWE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AARJ;;AAWE;EACE,sBAAA;EACA,eAAA;AARJ;;AAWE;EACI,oBAAA;AARN","sourcesContent":["// .mat-radio-button ~ .mat-radio-button {\r\n//     margin-left: 16px;\r\n// }\r\n\r\n.table {\r\n    margin-bottom: 0;\r\n    // font-family:inherit;\r\n  }\r\n  \r\n//   .mat-cell {\r\n//     // font-size: 12px;\r\n//   }\r\n  \r\n  .table th {\r\n    padding: .5rem;\r\n    font-weight: 600;\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .table td {\r\n    vertical-align: middle;\r\n    padding: .5rem\r\n  }\r\n\r\n  .table td mat-checkbox label {\r\n      margin: 0 !important\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
